import React from "react";

function CloudIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="18"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 32 32"
    >
      <g fill="#fffefe" data-name="Layer 14">
        <path
          d="M25 14a5 5 0 00-5-5 4.93 4.93 0 00-2.49.68A6 6 0 006 12a5.67 5.67 0 00.37 2A5 5 0 007 24h2a1 1 0 000-2H7a3 3 0 010-6h1a1 1 0 00.8-1.6A3.94 3.94 0 018 12a4 4 0 018-.44 1 1 0 001.76.53A3 3 0 0123 14a3.23 3.23 0 01-.11.75 1 1 0 001 1.25H25a3 3 0 010 6h-2a1 1 0 000 2h2a5 5 0 000-10z"
          data-original="#000000"
        ></path>
        <path
          d="M19.29 20.29L17 22.59V16a1 1 0 00-2 0v6.59l-2.29-2.3a1 1 0 00-1.42 1.42l4 4a1 1 0 001.42 0l4-4a1 1 0 00-1.42-1.42z"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  );
}

export default CloudIcon;
